import React, { useEffect } from 'react';
import { Modules } from '~/components/modules';
import SEO from '~/components/meta/SEO';
import { useSiteContext } from '~/context/SiteContext';
import { htmlToText } from '~/utils/helpers';
import { Container } from '~/components/layout/PageStructure';
import { LoadableLOTWConnector } from '~/components/live/LoadableLOTWConnector';
import webstoreTracker, {
  ContentGroups,
} from '~/helpers/trackers/webstoreTrackerWrapper';

const HomePage = () => {
  const {
    homePage: modules,
    globals: { shopInfo },
  } = useSiteContext();
  const { homepageTitle, homepageDescription } = shopInfo;

  useEffect(() => {
    webstoreTracker.tagGroup(ContentGroups.HomePage);
  }, []);

  return (
    <>
      <SEO
        title={homepageTitle}
        description={htmlToText(homepageDescription)}
      />

      <Container className={'my-6'}>
        <LoadableLOTWConnector autoConnectToReplay={false} />
      </Container>

      {modules.map((module: any) => (
        <Modules data={module} type={module.type} key={module.id} />
      ))}
    </>
  );
};
export default HomePage;
